export default __webpack_public_path__ + "static/media/typing_searching.02a96477.png";